import { Component, OnInit } from '@angular/core';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { averageNumberTransactionsOptions } from '@app/forms/subscription/services/ref';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

@Component({
    selector: 'scpi-average-number-transactions',
    templateUrl: './scpi-average-number-transactions.component.html',
    styleUrls: ['./scpi-average-number-transactions.component.scss'],
    standalone: false
})
export class ScpiAverageNumberTransactionsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options = averageNumberTransactionsOptions;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
